(function() {
  const WALL_HEIGHT_CM = 260;
  const ASPECT_RATIO = 16 / 9;
  const WALL_WIDTH_CM = WALL_HEIGHT_CM * ASPECT_RATIO; // ~462.2cm

  function init() {
    const btn = document.querySelector('#view-in-room-btn');
    const modal = document.querySelector('#view-in-room-modal');
    if (!btn || !modal) return;

    btn.onclick = () => {
      modal.style.display = 'flex';
      renderArt(modal);
    };

    const close = () => {
      modal.style.display = 'none';
    };

    modal.querySelector('.vir-close').onclick = close;
    modal.onclick = (e) => { if (e.target === modal) close(); };
  }

  function renderArt(modal) {
    const artWrapper = modal.querySelector('.vir-art-wrapper');
    const desc = (document.title + ' ' + (document.querySelector('.product__description')?.innerText || '')).toLowerCase();
    
    // Regex for dimensions like 26.77 x 37.8" or 68 x 96 cm
    const dimRegex = /(\d+(?:\.\d+)?)\s*[x*×]\s*(\d+(?:\.\d+)?)\s*(inch|cm|"|”)?/i;
    const match = desc.match(dimRegex);
    
    let wCm = 40;
    let hCm = 50;

    if (match) {
      let w = parseFloat(match[1]);
      let h = parseFloat(match[2]);
      let unit = match[3];
      
      if (!unit || unit === '"' || unit === '”' || unit === 'inch') {
        wCm = w * 2.54;
        hCm = h * 2.54;
      } else {
        wCm = w;
        hCm = h;
      }
    }

    // Calculate width percentage based on wall height 260cm (16:9 ratio)
    // We use height as the primary anchor for vertical scrolls like these
    const pctHeight = (hCm / WALL_HEIGHT_CM) * 100;
    const pctWidth = (wCm / WALL_WIDTH_CM) * 100;

    artWrapper.style.width = pctWidth + '%';
    artWrapper.style.transform = 'translateY(-15%)'; // Position on the upper part of the wall
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();